const NS = 'KlevuResultsListingBlock';
const CLS = 'klevuResultsListingBlock';
const CLS_LOADING = 'is-loading';
const EVT_SEARCH_START = `${CLS}.search.start`;
const EVT_SEARCH_END = `${CLS}.search.end`;

export class KlevuResultsListingBlock {

	constructor(el) {
		// $el is the blk node return by the loadKlevuResultsListingBlock function
		this.el = el;
		this.$el = $(el);

		this.checkQueryString();
		this.attachEvent();
	}

	checkQueryString() {
		let urlParams = new URLSearchParams(window.location.search);
		if (Array.from(urlParams).length > 0) {
			this.$el.addClass(CLS_LOADING);
		}
	}

	attachEvent() {
		this.el.addEventListener(EVT_SEARCH_START, () => {
			this.$el.addClass(CLS_LOADING);
		});

		this.el.addEventListener(EVT_SEARCH_END, () => {
			this.$el.removeClass(CLS_LOADING);
		});
	}

	/*
	Need to append code below manually to each Klevu module like sort, limit, pagination, etc,
	cause couldn't find a generic function to call this loading

	var $landing = document.querySelector('.klevuResultsListingBlock');
	if ($landing) {
		var searchStartEvent = new CustomEvent('klevuResultsListingBlock.search.start');
		$landing.dispatchEvent(searchStartEvent);
	}
	*/
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/408/s/FrontEnd/src/views/blocks/klevuResultsListingBlock/js/klevuResultsListingBlock.js